import type { RootState } from '@/store/root-reducer';

const selectTrackedLpsState = (state: RootState) => state.trackedLps;

export const selectRows = (state: RootState) => selectTrackedLpsState(state).rows;
export const selectTotal = (state: RootState) => selectTrackedLpsState(state).total;
export const selectLoading = (state: RootState) => selectTrackedLpsState(state).loading;
export const selectLoaded = (state: RootState) => selectTrackedLpsState(state).loaded;
export const selectError = (state: RootState) => selectTrackedLpsState(state).error;
export const selectPage = (state: RootState) => selectTrackedLpsState(state).page;
export const selectPageSize = (state: RootState) => selectTrackedLpsState(state).pageSize;
export const selectFilters = (state: RootState) => selectTrackedLpsState(state).filters;
export const selectSort = (state: RootState) => selectTrackedLpsState(state).sort;
